<template>
    <section id="default-page">
        <div class="container full-width">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>
                                Claims
                            </h2>
                        </div>
                        <div class="right">
                            <a href="/files/SBL_Claims_Policy_October_2022.pdf" target="_blank" class="btn btn-primary">
                                View Claims policy
                            </a>
                        </div>
                    </div>
                    <div class="bottom">
                        <small class="ml-auto">If you'd like to make a claim, please go to <a href="/my-garage">My Garage</a> and select the relevant vehicle.</small>
                    </div>
                </div>
                <div class="container-table">
                    <b-table
                        class="list-table"
                        responsive=""
                        :fields="fields"
                        :items="claims"
                        show-empty
                    >
                        <template v-slot:empty="scope">
                            You have no claims
                        </template>
                        <template v-slot:cell(action)="data">
                            <div>
                                <a :href="$laravelRoute('claims.show', data.item.id)" class="link">View</a>
                                <a :href="$laravelRoute('claims.edit', data.item.id)" class="link">Edit</a>
                                <a href="#!" @click.prevent="deleteClaim(data.item)" class="link">Delete</a>
                            </div>
                        </template>
                        <template v-slot:cell(user)="data">
                            <template v-if="data.item && data.item.user">
                                {{data.item.user.name}}
                            </template>
                        </template>
                        <template v-slot:cell(vehicle)="data">
                            <div v-if="data.item.vehicle">
                                {{data.item.vehicle.make}} {{data.item.vehicle.model}}, {{data.item.vehicle.year}}
                            </div>
                            <div v-else>
                                {{data.item.make}} {{data.item.model}}, {{data.item.chassis}}
                            </div>
                        </template>
                        <template v-slot:cell(status)="data">
                            <div v-if="data.item.status == 1">
                                <span class="badge badge-warning">Pending</span>
                            </div>
                            <div v-else-if="data.item.status == 2">
                                <span class="badge badge-primary">In Process</span>
                            </div>
                            <div v-else-if="data.item.status == 3">
                                <span class="badge badge-success">Processed</span>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="bottom-table">
                    <b-pagination
                        v-if="total > 0"
                        :total-rows="total"
                        v-model="current_page"
                        :per-page="per_page"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import {getDate, getExceptionErrorMessage} from '../../util/common'
import axios from "axios";
import {mapMutations, mapState} from "vuex";
export default {
    async created(){
        await this.$store.dispatch('claims/getList');
    },
    data() {
        return {
            sort_by: 'created_at',
            sort_asc: false,
            fields: [
                {label: 'Claim Date', key: 'created_at', sortable: false, formatter: v => getDate(v)},
                {label: 'User', key: 'user', sortable: false},
                {label: 'Vehicle', key: 'vehicle', sortable: false},
                {label: 'Reason', key: 'reason', sortable: false},
                {label: 'Status', key: 'status', sortable: false},
                {label: 'Action', key: 'action', sortable: false},
            ],
        }
    },
    computed: {
        ...mapState({
            claims: state => state.claims.all,
            per_page: state => state.claims.per_page,
            from: state => state.claims.from,
            to: state => state.claims.to,
            last_page: state => state.claims.last_page,
            total: state => state.claims.total,
        }),
        current_page: {
            get(){
                return this.$store.getters['claims/getCurrentPage'];
            },
            set(value){
                this.setPage(value)
                this.$store.dispatch('claims/getList');
            }
        },
    },
    methods: {
        ...mapMutations({
            setPage: 'claims/setPage'
        }),
        async deleteClaim(claim){
            try {
                await this.$confirm('Are you sure you want to delete ' +claim.id+ '?')
            } catch (e) {
                console.log('Delete cancelled')
                return;
            }
            try {
                const res = await axios.delete(this.$laravelRoute('claims.destroy', claim.id))
                if (res && res.data && res.data.message) {
                    this.$message({
                        message: res.data.message,
                        type: 'success'
                    });
                    await this.$store.dispatch('claims/getList');
                }
            } catch (e) {
                let msg = getExceptionErrorMessage(e)
                if (!msg) {
                    msg = 'There was a problem deleting the claim.'
                }
                this.$message.error(msg);
            }
        },
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/Claims/List.vue